export default __webpack_public_path__ + "static/media/Battlewarden.61018ddc.jpg";